import { makeAutoObservable } from 'mobx';
import { IMultipleFilter } from '@tools/ui/types';

class FilterStore {
  filters: Record<string, IMultipleFilter> = {};
  filterChanged = false;

  constructor() {
    makeAutoObservable(this);
  }

  setFilterChanged() {
    this.filterChanged = !this.filterChanged;
  }

  addFilter(filter: IMultipleFilter) {
    this.filters[filter.text] = filter;
  }

  removeByDottedPaths(paths: string[]) {
    paths.forEach((path) => {
      const filterKeys = Object.keys(this.filters).filter(
        (key) => this.filters[key].dottedPath === path
      );

      filterKeys.forEach((filterKey) => {
        delete this.filters[filterKey];
      });
    });
  }

  removeFilter(filter: IMultipleFilter) {
    if (this.filters[filter.text]) {
      delete this.filters[filter.text];
    }
  }

  removeFilters(filters: IMultipleFilter[]) {
    filters.forEach((filter) => {
      this.removeFilter(filter);
    });
    this.setFilterChanged();
  }

  clearFilters() {
    this.filters = {};
    this.setFilterChanged();
  }

  getFilter(key: string) {
    return this.filters[key];
  }

  get Filters() {
    return Object.values(this.filters);
  }

  initFilters(filters: IMultipleFilter[]) {
    const filterMap: Record<string, IMultipleFilter> = {};

    filters.forEach((filter) => {
      filterMap[filter.text] = filter;
    });

    this.filters = filterMap;
  }
}

export default new FilterStore();
